import { useContext, useEffect, useState } from 'react';
import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';

import NotifyForm from '../../components/NotifyForm/NotifyForm';

import './Notify.scss';
import HeaderNavigation from '../../components/HeaderNavigation/HeaderNavigation';

interface Props {
    handleHeaderCancel: () => void;
}

function Notify({ handleHeaderCancel }: Props) {
    const { t } = useTranslation();
    const [success, setSuccess] = useState(false);
    const [packages, setPackages] = useState([]);
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, center } = state;

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [dispatch]);

    const handleBackArrow = () => {
        // dispatch({ type: 'SET_NOTIFY_ME', payload: false });
    }

    return (
        <div className="FTTH__NotifyContainer">
            <HeaderNavigation
                rtl={rtl}
                percent={50}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Notify__heading'>
                <Typography rtl={rtl} className='title'>{t('Notify_me')}</Typography>
                <Typography rtl={rtl} className='subTitle'>{t("Please_fill_in_the_following")}</Typography>
                <Typography rtl={rtl} className='subTitle'>{t("We_Want_Details_ODB_Req")}</Typography>
            </div>

            <NotifyForm setSuccess={setSuccess} packages={packages} rtl={rtl} center={center} />
        </div>
    )
}

export default Notify